module.exports = __webpack_public_path__ + "static/img/shiye_img4@2x.9e01f447.jpg";